import type { PageContent } from '../schema';

export const contactPageContent = {
  id: 'contact',
  title: 'Contact Sree Silks',
  description: 'Contact our stylists and gifting experts for collections, wedding gifting, and custom orders.',
  sections: [
    {
      id: 'inquiry',
      title: "Tell us what you're looking for and we'll take it from there.",
      description: 'Product guidance, gifting consultations, invoice support, and store visit coordination.',
    },
    {
      id: 'testimonials',
      title: 'What Our Clients Say',
    },
  ],
} satisfies PageContent;
